var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconPatients = function SvgIconPatients(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.0204082,0.348794063 C10.5056772,0.348794063 0.348794063,10.5056772 0.348794063,23.0204082 C0.348794063,35.5351391 10.5056772,45.6920223 23.0204082,45.6920223 C35.5351391,45.6920223 45.6920223,35.5351391 45.6920223,23.0204082 C45.6920223,10.5056772 35.5351391,0.348794063 23.0204082,0.348794063 L23.0204082,0.348794063 Z M23.0204082,7.15027829 C26.7838961,7.15027829 29.8218924,10.1882746 29.8218924,13.9517625 C29.8218924,17.7152505 26.7838961,20.7532468 23.0204082,20.7532468 C19.2569202,20.7532468 16.2189239,17.7152505 16.2189239,13.9517625 C16.2189239,10.1882746 19.2569202,7.15027829 23.0204082,7.15027829 L23.0204082,7.15027829 Z M23.0204082,39.3439703 C17.3525046,39.3439703 12.3420779,36.4420037 9.4174397,32.0437106 C9.48545455,27.5320594 18.4860853,25.0608534 23.0204082,25.0608534 C27.5320594,25.0608534 36.5553618,27.5320594 36.6233766,32.0437106 C33.6987384,36.4420037 28.6883117,39.3439703 23.0204082,39.3439703 L23.0204082,39.3439703 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.-icons-/-user-profile",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconPatients);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-patients.f7c1b36371bf80fa26496a407664e08f.svg";